// extracted by mini-css-extract-plugin
export default {"postsBtn":"posts_postsBtn__lS03m","postsWalletBtn":"posts_postsWalletBtn__MkRad"};